import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    auth,
    facebookAuthProvider,
    githubAuthProvider,
    googleAuthProvider,
    twitterAuthProvider
} from "../firebase/firebase";

import {
    SIGNIN_FACEBOOK_USER,
    SIGNIN_GITHUB_USER,
    SIGNIN_GOOGLE_USER,
    SIGNIN_TWITTER_USER,
    SIGNIN_USER,
    SIGNIN_CONTROLLER,
    SIGNIN_METHOD,
    SIGNOUT_METHOD,
    SIGNIN_MODULE,
    SIGNOUT_USER,
    SIGNUP_USER//,
    //RESET_PASSWORD_METHOD
} from "constants/ActionTypes";
import { showAuthMessage, userSignInSuccess, userSignOutSuccess, userSignUpSuccess } from "actions/Auth";
import {
    userFacebookSignInSuccess,
    userGithubSignInSuccess,
    userGoogleSignInSuccess,
    userTwitterSignInSuccess
} from "../actions/Auth";

import ClientRequestService from "../services/ClientRequestService";
import AuthUserService from "../services/AuthUserService";
import AppConfigService from "../services/AppConfigService";
import { Util } from '../services/Util';

const createUserWithEmailPasswordRequest = async (email, password) =>
    await auth.createUserWithEmailAndPassword(email, password)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithEmailPasswordRequest = async (email, password) =>
    await new ClientRequestService(SIGNIN_MODULE).Post(
        {
            url: `${SIGNIN_CONTROLLER}/${SIGNIN_METHOD}`,
            withModule: false,
            data: { UserName: email, Password: password },
            getRawResponse: true,
            handleCallerException: true
        })
        .then(authUser => authUser);

/*const resetPasswordWithEmailAndUserName = async (Email, UserName) =>
await new ClientRequestService(SIGNIN_MODULE).Post(
    {
        url: `${SIGNIN_CONTROLLER}/${RESET_PASSWORD_METHOD}`,
        withModule: false,
        data: { Email: Email, UserName: UserName },
        getRawResponse: true
    })
    .then(authUser => authUser);*/

const signOutRequest = async () =>
    await new ClientRequestService(SIGNIN_MODULE).Get(
        {
            url: `${SIGNIN_CONTROLLER}/${SIGNOUT_METHOD}`,
            withModule: false,
            getRawResponse: true
        }
    ).then(authUser => authUser);

const signInUserWithGoogleRequest = async () =>
    await auth.signInWithPopup(googleAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithFacebookRequest = async () =>
    await auth.signInWithPopup(facebookAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithGithubRequest = async () =>
    await auth.signInWithPopup(githubAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithTwitterRequest = async () =>
    await auth.signInWithPopup(twitterAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

function* createUserWithEmailPassword({ payload }) {
    const { email, password } = payload;
    try {
        const signUpUser = yield call(createUserWithEmailPasswordRequest, email, password);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            new AuthUserService().setUser({
                UserId: signUpUser.user.uid
            });

            yield put(userSignUpSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithGoogle() {
    try {
        const signUpUser = yield call(signInUserWithGoogleRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            new AuthUserService().setUser({
                UserId: signUpUser.user.uid
            });

            yield put(userGoogleSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithFacebook() {
    try {
        const signUpUser = yield call(signInUserWithFacebookRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            new AuthUserService().setUser({
                UserId: signUpUser.user.uid
            });

            yield put(userFacebookSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithGithub() {
    try {
        const signUpUser = yield call(signInUserWithGithubRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            new AuthUserService().setUser({
                UserId: signUpUser.user.uid
            });

            yield put(userGithubSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithTwitter() {
    try {
        const signUpUser = yield call(signInUserWithTwitterRequest);
        if (signUpUser.message) {
            if (signUpUser.message.length > 100) {
                yield put(showAuthMessage('Your request has been canceled.'));
            } else {
                yield put(showAuthMessage(signUpUser.message));
            }
        } else {
            new AuthUserService().setUser({
                UserId: signUpUser.user.uid
            });

            yield put(userTwitterSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithEmailPassword({ payload }) {
    const { email, password } = payload;

    try {
        const signInUser = yield call(signInUserWithEmailPasswordRequest, email, password);
        if (signInUser.ResponseCode !== "OK") {
            yield put(showAuthMessage(signInUser.Message));            
        } else {
            var authUserService = new AuthUserService();

            authUserService.setUser({
                UserID: signInUser.Result.UserID,
                LogedId: signInUser.Result.LogedID,
                UserName: signInUser.Result.UserName,
                CompanyName: signInUser.Result.CompanyName,
                EmployeeID: signInUser.Result.EmployeeID,
                ApplicationName: signInUser.Result.ApplicationName
            });

            authUserService.setToken(signInUser.Result.Token);
            new AppConfigService().setDateFormat(signInUser.Result.DateFormat);
            new Util().hideNotificationMsg();
            yield put(userSignInSuccess(signInUser.Result.UserID));
        }
    } catch (error) {
        yield put(showAuthMessage(error.response ? error.response.data.message : "Unspecified Error!"));
    }
}

function* signOut() {
    try {
        const signOutUser = yield call(signOutRequest);
        if (signOutUser.ResponseCode === "OK") {
            new AuthUserService().logOut();
            yield put(userSignOutSuccess(signOutUser));
        } else {
            yield put(showAuthMessage(signOutUser.Message));
        }
    } catch (error) {
        yield put(showAuthMessage(error.response ? error.response.data.message : "Unspecified Error!"));
    }
}

export function* createUserAccount() {
    yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInWithGoogle() {
    yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
}

export function* signInWithFacebook() {
    yield takeEvery(SIGNIN_FACEBOOK_USER, signInUserWithFacebook);
}

export function* signInWithTwitter() {
    yield takeEvery(SIGNIN_TWITTER_USER, signInUserWithTwitter);
}

export function* signInWithGithub() {
    yield takeEvery(SIGNIN_GITHUB_USER, signInUserWithGithub);
}

export function* signInUser() {
    yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
    yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
    yield all(
        [
            fork(signInUser),
            fork(createUserAccount),
            fork(signInWithGoogle),
            fork(signInWithFacebook),
            fork(signInWithTwitter),
            fork(signInWithGithub),
            fork(signOutUser)
        ]
    );
}
